import { Routes } from "@angular/router"
import { captainLinks, captainProfileLinks } from "./captain-portal/captain-portal-links"
import { clientLinks, clientProfileLinks } from "./client-portal/client-portal-links"
import { ForbiddenComponent } from "./forbidden/forbidden.component"
import { EmptyLayoutComponent } from "./layouts/empty/empty-layout.component"
import { LoggedInLayoutComponent } from "./layouts/logged-in/logged-in-layout.component"
import { superLinks, superProfileLinks } from "./super-portal/super-portal-links"
import { testerLinks, testerProfileLinks } from "./tester-portal/tester-portal-links"

export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: LoggedInLayoutComponent,
    data: {
      links: clientLinks,
      profileLinks: clientProfileLinks,
      portal: "client",
    },
    loadChildren: async () => import("./client-portal/client-portal.module").then(m => m.ClientPortalModule),
  },
  {
    path: "tester",
    component: LoggedInLayoutComponent,
    data: {
      links: testerLinks,
      profileLinks: testerProfileLinks,
      portal: "tester",
    },
    loadChildren: async () => import("./tester-portal/tester-portal.module").then(m => m.TesterPortalModule),
  },
  {
    path: "captain",
    component: LoggedInLayoutComponent,
    data: {
      links: captainLinks,
      profileLinks: captainProfileLinks,
      portal: "captain",
    },
    loadChildren: async () => import("./captain-portal/captain-portal.module").then(m => m.CaptainPortalModule),
  },
  {
    path: "super",
    component: LoggedInLayoutComponent,
    data: {
      links: superLinks,
      profileLinks: superProfileLinks,
      portal: "super",
    },
    loadChildren: async () => import("./super-portal/super-portal.module").then(m => m.SuperPortalModule),
  },
  {
    path: "pages",
    component: EmptyLayoutComponent,
    loadChildren: async () => import("./pages/pages.module").then(m => m.PagesModule),
  },
  {
    path: "demo",
    component: EmptyLayoutComponent,
    loadChildren: async () => import("./demo/demo.module").then(m => m.DemoModule),
  },
  {
    path: "forbidden",
    component: ForbiddenComponent,
  },
  {
    path: "**",
    redirectTo: "/dashboard",
    pathMatch: "full",
  },
]
